export default __webpack_public_path__ + "static/media/loginBack.9d5044cd.png";